import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import "./NavigationButton.css"
import { Button } from '@mui/material'

interface NavigationButtonProps {
  title: string
  onClick: () => void
}

export const NavigationButton = ({ title, onClick }: NavigationButtonProps) => {
  return (
    <Button
      className="portal-card navigation-button"
      variant="contained"
      onClick={onClick}
      endIcon={<ArrowForwardIcon fontSize="medium" className="arrow-icon" />}
    >
      {title}
    </Button>
  )
}